import { toCurrencyString } from '@plato/ui-legacy/lib/currency-helpers';
import { useResolvedLocale } from '@plato/ui-legacy/lib/hooks/locale';
import {
    Collapsible,
    CollapsibleHeader,
    CollapsibleHeading,
    CollapsiblePanel,
    CollapsibleSubtitle,
    CollapsibleTitle,
    CollapsibleTrigger,
} from '@plato/ui/containers/collapsible';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type LogInteractionOfferSectionProps = {
    /** Sent quotes only, so a draft's total doesn't inflate the summary. */
    quoteCount: number;
    quoteTotal: number;
    state: 'pending' | 'empty' | 'ready';
    defaultOpen?: boolean;
    children?: ReactNode;
};

export function LogInteractionOfferSection({
    quoteCount,
    quoteTotal,
    state,
    defaultOpen,
    children,
}: LogInteractionOfferSectionProps): ReactNode {
    const { t } = useTranslation('notes');
    const locale = useResolvedLocale();

    return (
        <Collapsible defaultOpen={defaultOpen}>
            <CollapsibleHeader>
                <CollapsibleHeading>
                    <CollapsibleTitle>{t('notes__offers_section_title')}</CollapsibleTitle>
                    {quoteCount > 0 && (
                        <CollapsibleSubtitle>
                            {t('notes__offers_section_summary', {
                                count: quoteCount,
                                total: toCurrencyString(quoteTotal, locale),
                            })}
                        </CollapsibleSubtitle>
                    )}
                </CollapsibleHeading>
                <CollapsibleTrigger />
            </CollapsibleHeader>
            <CollapsiblePanel>
                {state === 'ready' ? (
                    <div className="flex flex-col gap-cozy">{children}</div>
                ) : (
                    <p className="text-body text-content-weak">
                        {state === 'pending'
                            ? t('notes__offers_section_loading')
                            : t('notes__offers_section_empty')}
                    </p>
                )}
            </CollapsiblePanel>
        </Collapsible>
    );
}
